import Layout from "../components/layout";
import {GetStaticProps} from "next";
import ThankYouSection from "../components/v2/common/thankyou";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import nextI18NextConfig from "../next-i18next.config";
import "../styles/scss/contact-us.module.scss";

const ThankYou = () => {
    return <>
        <Layout
            isHomePage={false}
            pageTitle={"Thank You for Your Request | Middleware"}
            ogImage={""}
            uri={"/thank-you/"}
            metaTitle={"Thank You for Your Request | Middleware"}
            metaDesc={"Thank you for reaching out to Middleware!  Expect a response within 24 hours."}
            metaRobotsNoindex={"index"}
            metaRobotsNofollow={"follow"}
        >

            <ThankYouSection title={<h1><span className={"text-gradient"}>Thank You </span> for Showing Your Interest!</h1>} description={"We will review your request, and our observability expert will get back to you within 24 hours."} img={"/images/contact-us/thankyou.svg"} imgAlt={"Infra Monitoring"} hasActions={true} className={"thank-you technology"}/>

        </Layout>
    </>
}
export const getStaticProps: GetStaticProps = async ({ locale }) => {

    return {
        props: {
            pageData: "",
            pageTitle: "Thank You for Your Request | Middleware",
            description: "Thank you for reaching out to Middleware!  Expect a response within 24 hours.",
            ogImage: "",
            uri: "/thank-you/",
            metaTitle: "Thank You for Your Request | Middleware",
            metaDesc: "Thank you for reaching out to Middleware!  Expect a response within 24 hours.",
            metaRobotsNoindex: "index",
            metaRobotsNofollow: "follow",
            ...(await serverSideTranslations(locale ?? 'en', ['common', 'header', 'footer'], nextI18NextConfig)),
        },
    }
}
export default ThankYou;